import React from 'react'
import { Observer } from 'mobx-react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import UserRoute from 'src/routes/UserRoute'
import UserSessionRoute from 'src/routes/UserSessionRoute'
import GroupRoute from 'src/routes/GroupRoute'
import SupplierRoute from 'src/routes/SupplierRoute'
import TenantRoute from 'src/routes/TenantRoute'
import ServiceRoute from 'src/routes/ServiceRoute'
import ApplicationRoute from 'src/routes/ApplicationRoute'
import { Header } from 'src/components/Header'
import InternalServerError from 'src/routes/InternalServerError'
import Logout from 'src/routes/Logout'
import ErrorBoundary from 'src/components/ErrorBoundary'
import NotFound from 'src/routes/NotFound'
import HomePage from 'src/routes/HomePage'
import GroupForm from 'src/components/Forms/GroupForm'
import DefaultGroupCreate from 'src/routes/DefaultGroupCreate'
import ServiceForm from 'src/components/Forms/ServiceForm'
import ApplicationForm from 'src/components/Forms/ApplicationForm'
import ServiceActionForm from 'src/components/Forms/ServiceActionForm'
import TenantForm from 'src/components/Forms/TenantForm'
import UserForm from 'src/components/Forms/UserForm'
import AppPermissionsForm from 'src/components/Forms/AppPermissionsForm'
import { authenticatedUserStore, notifierStore } from 'src/stores'
import UnauthorizedPage from 'src/routes/UnauthorizedPage'
import { Notifier } from 'src/components/Notifier'
import Crumbs from 'src/components/Crumbs'
import UserImportWizard from 'src/routes/UserImportWizard'
import GlobalAdminRoute from 'src/routes/GlobalAdminRoute'
import './mainRoute.scss'

class Main extends React.Component {
    render() {
        return (
            <Router>
                <Header globalAdmin={authenticatedUserStore.isGlobalAdmin} />
                <div className={'notifier-wrapper'}>
                    <Observer>
                        {() => {
                            return (
                                <Notifier>
                                    <Notifier.Toast
                                        variant={
                                            notifierStore.toastInfo.didSucceed
                                                ? 'success'
                                                : 'danger'
                                        }
                                        title={
                                            notifierStore.toastInfo.didSucceed
                                                ? 'Submit succeeded'
                                                : 'Submit failed'
                                        }
                                    >
                                        {notifierStore.toastInfo.message}
                                    </Notifier.Toast>
                                </Notifier>
                            )
                        }}
                    </Observer>
                </div>
                <Switch>
                    {/*this needs to be outside because we redirect to it from the ErrorBoundary*/}
                    <Route
                        exact
                        path={'/internal-error'}
                        component={InternalServerError}
                    />
                    <Route>
                        <ErrorBoundary>
                            <Switch>
                                <Route
                                    path={'/groups'}
                                    render={routeProps => (
                                        <Observer>
                                            {() => {
                                                return (
                                                    <>
                                                        <Crumbs
                                                            breadcrumbs={[
                                                                {
                                                                    label: 'Groups',
                                                                },
                                                            ]}
                                                            path={'/groups'}
                                                            {...routeProps}
                                                        />
                                                        <GroupRoute
                                                            {...routeProps}
                                                            entity="group"
                                                            selectedOrganization={
                                                                authenticatedUserStore.selectedOrganization
                                                            }
                                                        />
                                                    </>
                                                )
                                            }}
                                        </Observer>
                                    )}
                                />
                                <Route
                                    path={'/users'}
                                    render={routeProps => (
                                        <Observer>
                                            {() => {
                                                return (
                                                    <>
                                                        <Crumbs
                                                            breadcrumbs={[
                                                                {
                                                                    label: 'Users',
                                                                },
                                                            ]}
                                                            path={'/users'}
                                                            {...routeProps}
                                                        />
                                                        <UserRoute
                                                            {...routeProps}
                                                            entity="user"
                                                            selectedOrganization={
                                                                authenticatedUserStore.selectedOrganization
                                                            }
                                                        />
                                                    </>
                                                )
                                            }}
                                        </Observer>
                                    )}
                                />
                                <Route
                                    path={'/suppliers'}
                                    render={routeProps => (
                                        <>
                                            <Crumbs
                                                breadcrumbs={[
                                                    { label: 'Suppliers' },
                                                ]}
                                                path={'/suppliers'}
                                                {...routeProps}
                                            />
                                            <SupplierRoute
                                                {...routeProps}
                                                entity="supplier"
                                            />
                                        </>
                                    )}
                                />
                                <Route
                                    path={'/tenants'}
                                    render={routeProps => (
                                        <>
                                            <Crumbs
                                                breadcrumbs={[
                                                    { label: 'Tenants' },
                                                ]}
                                                path={'/tenants'}
                                                {...routeProps}
                                            />
                                            <TenantRoute
                                                {...routeProps}
                                                entity="tenant"
                                                organizationId={
                                                    authenticatedUserStore.currentOrganizationId
                                                }
                                                selectedOrganization={
                                                    authenticatedUserStore.selectedOrganization
                                                }
                                            />
                                        </>
                                    )}
                                />
                                {authenticatedUserStore.isGlobalAdmin && (
                                    <Route
                                        path={'/services'}
                                        render={routeProps => (
                                            <>
                                                <Crumbs
                                                    breadcrumbs={[
                                                        { label: 'Services' },
                                                    ]}
                                                    path={'/services'}
                                                    {...routeProps}
                                                />
                                                <ServiceRoute
                                                    {...routeProps}
                                                    entity="service"
                                                />
                                            </>
                                        )}
                                    />
                                )}
                                <Route
                                    path={'/application-form/:id'}
                                    render={routeProps => (
                                        <>
                                            <Crumbs
                                                breadcrumbs={[
                                                    {
                                                        label: 'Applications',
                                                        path: '/applications',
                                                    },
                                                    {
                                                        label: 'Edit application',
                                                    },
                                                ]}
                                                path={'/applications'}
                                                {...routeProps}
                                            />
                                            <ApplicationForm
                                                redirectUrl={'/applications'}
                                                entity="application"
                                                {...routeProps}
                                            />
                                        </>
                                    )}
                                />
                                <Route
                                    path={'/application-form'}
                                    render={routeProps => (
                                        <>
                                            <Crumbs
                                                breadcrumbs={[
                                                    {
                                                        label: 'Applications',
                                                        path: '/applications',
                                                    },
                                                    {
                                                        label: 'Create application',
                                                    },
                                                ]}
                                                path={'/applications'}
                                                {...routeProps}
                                            />
                                            <ApplicationForm
                                                redirectUrl={'/applications'}
                                                entity="application"
                                                {...routeProps}
                                            />
                                        </>
                                    )}
                                />
                                <Route
                                    path={
                                        '/group-form/:id/app-permissions-form/:permissionId'
                                    }
                                    render={routeProps => (
                                        <AppPermissionsForm
                                            redirectUrl={'/groups'}
                                            entity="app permission"
                                            {...routeProps}
                                        />
                                    )}
                                />
                                <Route
                                    path={
                                        '/group-form/:id/app-permissions-form'
                                    }
                                    render={routeProps => (
                                        <AppPermissionsForm
                                            redirectUrl={'/groups'}
                                            entity="app permission"
                                            {...routeProps}
                                        />
                                    )}
                                />
                                <Route
                                    path={'/group-form/:id'}
                                    render={routeProps => (
                                        <>
                                            <Crumbs
                                                breadcrumbs={[
                                                    {
                                                        label: 'Groups',
                                                        path: '/groups',
                                                    },
                                                    {
                                                        label: 'Edit group',
                                                    },
                                                ]}
                                                path={'/group-form/:id'}
                                                {...routeProps}
                                            />
                                            <GroupForm
                                                redirectUrl={'/groups'}
                                                entity="group"
                                                {...routeProps}
                                            />
                                        </>
                                    )}
                                />
                                <Route
                                    path={'/group-form'}
                                    render={routeProps => (
                                        <>
                                            <Crumbs
                                                breadcrumbs={[
                                                    {
                                                        label: 'Groups',
                                                        path: '/groups',
                                                    },
                                                    {
                                                        label: 'Create group',
                                                    },
                                                ]}
                                                path={'/group-form'}
                                                {...routeProps}
                                            />
                                            <GroupForm
                                                redirectUrl={'/groups'}
                                                entity="group"
                                                {...routeProps}
                                            />
                                        </>
                                    )}
                                />
                                <Route
                                    path={'/default-groups/create'}
                                    render={routeProps => (
                                        <>
                                            <Crumbs
                                                breadcrumbs={[
                                                    {
                                                        label: 'Groups',
                                                        path: '/groups',
                                                    },
                                                    {
                                                        label: 'Create default group',
                                                    },
                                                ]}
                                                path={'/default-groups/create'}
                                                {...routeProps}
                                            />
                                            <DefaultGroupCreate
                                                {...routeProps}
                                            />
                                        </>
                                    )}
                                />
                                <Route
                                    path={'/user-form/:username'}
                                    render={routeProps => (
                                        <>
                                            <Crumbs
                                                breadcrumbs={[
                                                    {
                                                        label: 'Users',
                                                        path: '/users',
                                                    },
                                                    {
                                                        label: 'Edit user',
                                                    },
                                                ]}
                                                path={'/user-form/:username'}
                                                {...routeProps}
                                            />
                                            <Observer>
                                                {() => {
                                                    return (
                                                        <UserForm
                                                            redirectUrl={
                                                                '/users'
                                                            }
                                                            selectedOrganization={
                                                                authenticatedUserStore.selectedOrganization
                                                            }
                                                            userIsGlobalAdmin={
                                                                authenticatedUserStore.isGlobalAdmin
                                                            }
                                                            entity="user"
                                                            {...routeProps}
                                                        />
                                                    )
                                                }}
                                            </Observer>
                                        </>
                                    )}
                                />
                                <Route
                                    path={'/global-admins/request'}
                                    render={routeProps => (
                                        <GlobalAdminRoute
                                            routeProps={routeProps}
                                        />
                                    )}
                                />
                                <Route
                                    path={'/user-form'}
                                    render={routeProps => (
                                        <>
                                            <Crumbs
                                                breadcrumbs={[
                                                    {
                                                        label: 'Users',
                                                        path: '/users',
                                                    },
                                                    {
                                                        label: 'Create user',
                                                    },
                                                ]}
                                                path={'/user-form'}
                                                {...routeProps}
                                            />
                                            <Observer>
                                                {() => {
                                                    return (
                                                        <UserForm
                                                            redirectUrl={
                                                                '/users'
                                                            }
                                                            entity="user"
                                                            selectedOrganization={
                                                                authenticatedUserStore.selectedOrganization
                                                            }
                                                            organizationId={
                                                                authenticatedUserStore.currentOrganizationId
                                                            }
                                                            userIsGlobalAdmin={
                                                                authenticatedUserStore.isGlobalAdmin
                                                            }
                                                            {...routeProps}
                                                        />
                                                    )
                                                }}
                                            </Observer>
                                        </>
                                    )}
                                />
                                <Route
                                    path={'/bulk-import-users'}
                                    render={routeProps => (
                                        <>
                                            <Crumbs
                                                breadcrumbs={[
                                                    {
                                                        label: 'Users',
                                                        path: '/users',
                                                    },
                                                    {
                                                        label: 'Bulk import',
                                                    },
                                                ]}
                                                path={'/bulk-import-users'}
                                                {...routeProps}
                                            />
                                            <Observer>
                                                {() => {
                                                    return (
                                                        <UserImportWizard
                                                            organizationId={
                                                                authenticatedUserStore.currentOrganizationId
                                                            }
                                                            {...routeProps}
                                                        />
                                                    )
                                                }}
                                            </Observer>
                                        </>
                                    )}
                                />
                                <Route
                                    path={
                                        '/service-form/:id/service-action/:actionId'
                                    }
                                    render={routeProps =>
                                        authenticatedUserStore.isGlobalAdmin ? (
                                            <>
                                                <Crumbs
                                                    breadcrumbs={[
                                                        {
                                                            label: 'Services',
                                                            path: '/services',
                                                        },
                                                        {
                                                            label: 'Edit service',
                                                            path: '/service-form/:id',
                                                        },
                                                        {
                                                            label: 'Edit service action',
                                                        },
                                                    ]}
                                                    path={
                                                        '/service-form/:id/service-action/:actionId'
                                                    }
                                                    {...routeProps}
                                                />
                                                <ServiceActionForm
                                                    redirectUrl={'/services'}
                                                    title="Edit service action"
                                                    {...routeProps}
                                                />
                                            </>
                                        ) : (
                                            <UnauthorizedPage noHeader={true} />
                                        )
                                    }
                                />
                                <Route
                                    path={'/service-form/:id/service-action'}
                                    render={routeProps =>
                                        authenticatedUserStore.isGlobalAdmin ? (
                                            <>
                                                <Crumbs
                                                    breadcrumbs={[
                                                        {
                                                            label: 'Services',
                                                            path: '/services',
                                                        },
                                                        {
                                                            label: 'Edit service',
                                                            path: '/service-form/:id',
                                                        },
                                                        {
                                                            label: 'Create service action',
                                                        },
                                                    ]}
                                                    path={
                                                        '/service-form/:id/service-action'
                                                    }
                                                    {...routeProps}
                                                />
                                                <ServiceActionForm
                                                    redirectUrl={'/services'}
                                                    title="Create service action"
                                                    {...routeProps}
                                                />
                                            </>
                                        ) : (
                                            <UnauthorizedPage noHeader={true} />
                                        )
                                    }
                                />
                                <Route
                                    path={'/service-form/:id'}
                                    render={routeProps =>
                                        authenticatedUserStore.isGlobalAdmin ? (
                                            <>
                                                <Crumbs
                                                    breadcrumbs={[
                                                        {
                                                            label: 'Services',
                                                            path: '/services',
                                                        },
                                                        {
                                                            label: 'Edit service',
                                                        },
                                                    ]}
                                                    path={'/service-form/:id'}
                                                    {...routeProps}
                                                />
                                                <ServiceForm
                                                    redirectUrl={'/'}
                                                    entity="service"
                                                    {...routeProps}
                                                />
                                            </>
                                        ) : (
                                            <UnauthorizedPage noHeader={true} />
                                        )
                                    }
                                />
                                <Route
                                    path={'/service-form'}
                                    render={routeProps =>
                                        authenticatedUserStore.isGlobalAdmin ? (
                                            <>
                                                <Crumbs
                                                    breadcrumbs={[
                                                        {
                                                            label: 'Services',
                                                            path: '/services',
                                                        },
                                                        {
                                                            label: 'Create service',
                                                        },
                                                    ]}
                                                    path={'/service-form'}
                                                    {...routeProps}
                                                />
                                                <ServiceForm
                                                    redirectUrl={'/'}
                                                    entity="service"
                                                    {...routeProps}
                                                />
                                            </>
                                        ) : (
                                            <UnauthorizedPage noHeader={true} />
                                        )
                                    }
                                />
                                <Route
                                    path={'/applications'}
                                    render={routeProps => (
                                        <Observer>
                                            {() => {
                                                return (
                                                    <>
                                                        <Crumbs
                                                            breadcrumbs={[
                                                                {
                                                                    label: 'Applications',
                                                                },
                                                            ]}
                                                            path={
                                                                '/applications'
                                                            }
                                                            {...routeProps}
                                                        />
                                                        <ApplicationRoute
                                                            {...routeProps}
                                                            entity="application"
                                                            selectedOrganization={
                                                                authenticatedUserStore.selectedOrganization
                                                            }
                                                            isGlobalAdmin={
                                                                authenticatedUserStore.isGlobalAdmin
                                                            }
                                                        />
                                                    </>
                                                )
                                            }}
                                        </Observer>
                                    )}
                                />
                                <Route
                                    path={'/user_sessions'}
                                    render={routeProps => (
                                        <Observer>
                                            {() => {
                                                return (
                                                    <>
                                                        <Crumbs
                                                            breadcrumbs={[
                                                                {
                                                                    label: 'User Sessions',
                                                                },
                                                            ]}
                                                            path={
                                                                '/user_sessions'
                                                            }
                                                            {...routeProps}
                                                        />
                                                        <UserSessionRoute
                                                            {...routeProps}
                                                            entity="user_session"
                                                            selectedOrganization={
                                                                authenticatedUserStore.selectedOrganization
                                                            }
                                                            isGlobalAdmin={
                                                                authenticatedUserStore.isGlobalAdmin
                                                            }
                                                        />
                                                    </>
                                                )
                                            }}
                                        </Observer>
                                    )}
                                />
                                <Route
                                    path={'/tenant-form/:id'}
                                    render={routeProps => (
                                        <Observer>
                                            {() => {
                                                return (
                                                    <>
                                                        <Crumbs
                                                            breadcrumbs={[
                                                                {
                                                                    label: 'Tenants',
                                                                    path: '/tenants',
                                                                },
                                                                {
                                                                    label: 'Edit tenant',
                                                                },
                                                            ]}
                                                            path={
                                                                '/tenant-form/:id'
                                                            }
                                                            {...routeProps}
                                                        />
                                                        <TenantForm
                                                            redirectUrl={'/'}
                                                            {...routeProps}
                                                            entity="tenant"
                                                        />
                                                    </>
                                                )
                                            }}
                                        </Observer>
                                    )}
                                />
                                <Route
                                    path={'/tenant-form'}
                                    render={routeProps => (
                                        <Observer>
                                            {() => {
                                                return (
                                                    <>
                                                        <Crumbs
                                                            breadcrumbs={[
                                                                {
                                                                    label: 'Tenants',
                                                                    path: '/tenants',
                                                                },
                                                                {
                                                                    label: 'Create tenant',
                                                                },
                                                            ]}
                                                            path={
                                                                '/tenant-form'
                                                            }
                                                            {...routeProps}
                                                        />
                                                        <TenantForm
                                                            redirectUrl={'/'}
                                                            {...routeProps}
                                                            entity="tenant"
                                                        />
                                                    </>
                                                )
                                            }}
                                        </Observer>
                                    )}
                                />
                                <Route
                                    path={'/logout'}
                                    render={routeProps => (
                                        <>
                                            <Crumbs
                                                breadcrumbs={[
                                                    {
                                                        label: 'Logout',
                                                    },
                                                ]}
                                                path={'/logout'}
                                                {...routeProps}
                                            />
                                            <Logout
                                                redirectUrl={'/'}
                                                {...routeProps}
                                            />
                                        </>
                                    )}
                                />
                                <Route
                                    path={'/'}
                                    exact
                                    render={routeProps => (
                                        <Observer>
                                            {() => {
                                                return (
                                                    <>
                                                        <Crumbs
                                                            breadcrumbs={[
                                                                {
                                                                    label: 'Home',
                                                                },
                                                            ]}
                                                            path={'/'}
                                                            {...routeProps}
                                                        />
                                                        <HomePage
                                                            {...routeProps}
                                                            selectedOrganization={
                                                                authenticatedUserStore.selectedOrganization
                                                            }
                                                        />
                                                    </>
                                                )
                                            }}
                                        </Observer>
                                    )}
                                />
                                <Route component={NotFound} />
                            </Switch>
                        </ErrorBoundary>
                    </Route>
                </Switch>
            </Router>
        )
    }
}

export default Main
